import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';

export const useAddLandingPlan = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (planId: string) => {
			try {
				const { data } = await api.post(`/management/landing/plan/addLandingPlan/${planId}`);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao adicionar plano à landing page');
			}
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: ['public-plans'] }),
				queryClient.invalidateQueries({ queryKey: ['management-plans'] }),
			]);
		},
	});
};
